import camelcaseKeysDeep from 'camelcase-keys-deep'
import { UnitRoundReportState } from './types'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, MutationNames } from './keys'
import { getters } from './getters'
import { getUnitRoundReportQueryByTimestamps } from '@/jsonapi/UnitRoundReport'

const state: UnitRoundReportState = {
  unitRoundReport: [],
  chosenOneMonthPeriod: null,
  chosenTwoWeekPeriod: null,
  chosenReportPeriod: null,
}

const mutations = {
  [MutationNames.updateUnitRoundReport](state, payload): void {
    state.unitRoundReport = payload
  },
  [MutationNames.updateChosenOneMonthPeriod](state, payload): void {
    state.chosenOneMonthPeriod = payload
  },
  [MutationNames.updateChosenTwoWeekPeriod](state, payload): void {
    state.chosenTwoWeekPeriod = payload
  },
  [MutationNames.updateChosenReportPeriod](state, payload): void {
    state.chosenReportPeriod = payload
  },
}

const actions = {
  async [ActionNames.getUnitRoundReportByTimestamps](
    { commit },
    params: {
      starttimestamp: number
      endtimestamp: number
    }
  ): Promise<void> {
    const results = camelcaseKeysDeep(
      await getUnitRoundReportQueryByTimestamps({
        starttimestamp: params.starttimestamp,
        endtimestamp: params.endtimestamp,
      })
    )
    commit(MutationNames.updateUnitRoundReport, results)
  },
}

export default {
  name: ModuleNames.unitRoundReport,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
